import { ApiState } from "./state";
import { AnyAction } from "redux";
import { Reducer } from "react";
import { UPDATE_API_FETCHING } from "../actions/api_details/types";

const initialState: ApiState = {
    isFetching: false,
};

const apiFetchReducer: Reducer<ApiState, AnyAction> = (state = initialState, action: AnyAction) => {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_API_FETCHING:
            return {
                isFetching: payload.status,
            };
        default:
            return state;
    }
};

export default apiFetchReducer;
